import React from "react";

export default function ProviderActivityCard({
  title,
  subtitle,
  total,
  pending,
  statusLabel,
  statusClassName,
  href,
  ctaLabel,
  accentClassName = "text-primary",
  icon = "bi-grid-1x2",
  isAr,
}) {
  return (
    <div className="card border-0 shadow-sm h-100 provider-center__activity-card">
      <div className="card-body d-flex flex-column">
        <div className="provider-center__activity-head mb-3">
          <div className="provider-center__activity-head-main">
            <div className="provider-center__activity-icon">
              <i className={`bi ${icon}`} />
            </div>
            <div className="provider-center__activity-copy">
              <div className="small text-muted provider-center__activity-subtitle">{subtitle}</div>
              <h5 className="mb-0 mt-1 provider-center__activity-title">{title}</h5>
            </div>
          </div>
          {statusLabel ? (
            <span className={`badge rounded-pill ${statusClassName} provider-center__activity-badge`}>
              {statusLabel}
            </span>
          ) : null}
        </div>

        <div className="provider-center__activity-stats mb-3">
          <div className="provider-center__activity-stat">
            <div className={`fs-3 fw-bold ${accentClassName}`}>{total}</div>
            <div className="small text-muted">{isAr ? "إجمالي العناصر" : "Total items"}</div>
          </div>
          <div className="provider-center__activity-stat">
            <div className="fs-5 fw-semibold">{pending}</div>
            <div className="small text-muted">{isAr ? "قيد المراجعة" : "Pending review"}</div>
          </div>
        </div>

        <a href={href} className="btn btn-outline-dark rounded-pill mt-auto provider-center__activity-cta">
          {ctaLabel}
        </a>
      </div>
    </div>
  );
}
